export default defineNuxtPlugin(() => {
  window.VERSION = "v1.0.0-99-g382359790";
});
